import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/recruit-positions/$recruitPositionId/recruitees/",
)({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div>
			Hello "/_authenticated/recruitPositions/$recruitPosition/recruitees/"!
		</div>
	);
}
